import { ERR_INVALID_ARGUMENT } from "../../../utils/error";
import { eq } from "../../../utils/math";
import { Texture } from "../Texture";
/** @internal */
export function seserializeTexture(pContext, pTexture) {
    if (pContext == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    if (!(pTexture instanceof Texture) || !pTexture.isResource)
        return (null);
    var tIOTex = {};
    //texture
    tIOTex.texture = pContext.addTexture(pTexture.id);
    //offset
    if (!eq(pTexture.uOffset, 0) || !eq(pTexture.vOffset, 0))
        tIOTex.offset = [pTexture.uOffset, pTexture.vOffset];
    //scale
    if (!eq(pTexture.uScale, 1) || !eq(pTexture.vScale, 1))
        tIOTex.scale = [pTexture.uScale, pTexture.vScale];
    //rotation
    if (!eq(pTexture.uAng, 0) || !eq(pTexture.vAng, 0) || !eq(pTexture.wAng, 0))
        tIOTex.rotation = [pTexture.uAng, pTexture.vAng, pTexture.wAng];
    return (tIOTex);
}
/** @internal */
export function deserializeTexture(pIOTextureMap, pContext, pMatManager) {
    if (pContext == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    var tTextureId = pContext.getTextureIdByIndex(pIOTextureMap.texture);
    if (tTextureId == null)
        return (null);
    var tTexture = pMatManager.getTexture(tTextureId);
    if (tTexture == null)
        return (null);
    if (pIOTextureMap.offset != null || pIOTextureMap.scale != null || pIOTextureMap.rotation != null) {
        //use clone to allow different texture matrix
        tTexture = tTexture.clone();
        //offset
        if (pIOTextureMap.offset != null) {
            tTexture.uOffset = pIOTextureMap.offset[0];
            tTexture.vOffset = pIOTextureMap.offset[1];
        }
        //scale
        if (pIOTextureMap.scale != null) {
            tTexture.uScale = pIOTextureMap.scale[0];
            tTexture.vScale = pIOTextureMap.scale[1];
        }
        //rotation
        if (pIOTextureMap.rotation != null) {
            tTexture.uAng = pIOTextureMap.rotation[0];
            tTexture.vAng = pIOTextureMap.rotation[1];
            tTexture.wAng = pIOTextureMap.rotation[2];
        }
        tTexture.notifyTextureMatrixChanged();
    }
    return (tTexture);
}
